/**
 * @deprecated Unused since the Auth0 migration. The state is retained so existing links to
 * /user/login still resolve, but no code navigates here - use `user.auth` instead.
 */
export const UserLoginState = {
	url: '/login',
	title: 'Login',
	redirectTo: 'user.auth', // deprecated OCA login; forward all navigation to Auth0 flow
	template: '<login-page></login-page>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "userLoginPageMod" */
			'@Containers/user-login-page/user-login-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
